export default __webpack_public_path__ + "static/media/vip-deposit-marathon-challenges-cn.3d86c6e1.webp";